import { createRouter, createWebHistory } from "vue-router";
// import { createRouter, createMemoryHistory  } from "vue-router";
import LoginPage from "../components/LoginPage.vue";
import MovieIndexPage from "../components/MovieIndexPage.vue";
import MovieDetailPage from "../components/MovieDetailPage.vue";
import BsListPage from "../components/BsListPage.vue";
import SeListPage from "../components/SeListPage.vue";
import SeListPageResponsive from "../components/SeListPageResponsive.vue";
import BmListPage from "../components/BmListPage.vue";
import PrListPage from "../components/PrListPage.vue";
import DrListPage from "../components/DrListPage.vue";
import DrListPopPage from "../components/DrListPopPage.vue";
import TrListPage from "../components/TrListPage.vue";
import TrListPopPage from "../components/TrListPopPage.vue";
import QcListPage from "../components/QcListPage.vue";
import CrListPage from "../components/CrListPage.vue";
import HcListPage from "../components/HcListPage.vue";
import HcListPopPage from "../components/HcListPopPage.vue";
import AmListPage from "../components/AmListPage.vue";
import EmListPage from "../components/EmListPage.vue";
import GtListPage from "../components/GtListPage.vue";
import ScListPage from "../components/ScListPage.vue";
import BrListPage from "../components/BrListPage.vue";
import ApListPage from "../components/ApListPage.vue";
import TsListPage from "../components/TsListPage.vue";
import BeListPage from "../components/BeListPage.vue";
import BcListPage from "../components/BcListPage.vue";
import LsListPage from "../components/LsListPage.vue";
import PeListPage from "../components/PeListPage.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/MovieIndexPage",
    name: "index",
    component: MovieIndexPage,
  },
  {
    path: "/:id",
    name: "detail",
    component: MovieDetailPage,
  },
  {
    path: "/BsListPage",
    name: "bsListPage",
    component: BsListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/SeListPage",
    name: "seListPage",
    component: SeListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/SeListPageResponsive",
    name: "SeListPageResponsive",
    component: SeListPageResponsive,
  },
  {
    path: "/BmListPage",
    name: "bmListPage",
    component: BmListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/PrListPage",
    name: "prListPage",
    component: PrListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/DrListPage",
    name: "drListPage",
    component: DrListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/DrListPopPage",
    name: "drListPopPage",
    component: DrListPopPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/TrListPage",
    name: "trListPage",
    component: TrListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/TrListPopPage",
    name: "trListPopPage",
    component: TrListPopPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/QcListPage",
    name: "qcListPage",
    component: QcListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/CrListPage",
    name: "crListPage",
    component: CrListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/HcListPage",
    name: "hcListPage",
    component: HcListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/HcListPopPage",
    name: "hcListPopPage",
    component: HcListPopPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/AmListPage",
    name: "amListPage",
    component: AmListPage,
    meta: { requiresAuth: true }, // 인증이 필요한 페이지임을 표시
  },
  {
    path: "/EmListPage",
    name: "emListPage",
    component: EmListPage,
    meta: { requiresAuth: true },
  },
  
  {
    path: "/GtListPage",
    name: "gtListPage",
    component: GtListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ScListPage",
    name: "scListPage",
    component: ScListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/BrListPage",
    name: "brListPage",
    component: BrListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/ApListPage",
    name: "apListPage",
    component: ApListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/TsListPage",
    name: "tsListPage",
    component: TsListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/BeListPage",
    name: "beListPage",
    component: BeListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/BcListPage",
    name: "bcListPage",
    component: BcListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/LsListPage",
    name: "lsListPage",
    component: LsListPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/PeListPage",
    name: "peListPage",
    component: PeListPage,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  // history: createMemoryHistory (),
  routes,
});

// 전역 네비게이션 가드 설정
router.beforeEach((to, from, next) => {
  // 이동하려는 페이지(to)가 인증을 필요로 하는지 확인합니다.
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // 인증이 필요한 페이지이지만, 사용자가 로그인하지 않은 경우
  // (여기서는 localStorage에 'user-token'이 있는지 여부로 간단히 확인)
  if (requiresAuth && !localStorage.getItem("isLogin")) {
    alert("로그인이 필요한 페이지입니다.");
    // 로그인 페이지로 리디렉션합니다.
    next({ path: "/" }); // 로그인 페이지 경로가 '/'라고 가정
    return;
  }
  const raw = localStorage.getItem("userInfo");
  const userInfo = raw ? JSON.parse(raw) : null;

  if (to.meta.requiresAuth) {
    // 인증 여부 확인
    if (!userInfo) {
      return next('/login'); // 로그인 안 했으면 로그인 페이지로
    }

    // 권한 체크
    if (to.path === '/BmListPage' && userInfo.OGN_FG !== '00') {
      return next('/PrListPage'); // 권한 없으면 홈으로 리다이렉트
    }

    if (to.path === '/GtListPage' && 
      (!['김정규', '김종배', '이재진', '육상용', '장영환', '남상만', '김춘규'].includes(userInfo.EMP_NM) &&
          !['관리자팀','판매전쟁실'].includes(userInfo.EMP_DEPT_NM))) {
      return next('/BmListPage');
    }

    if (to.path === '/PeListPage' && userInfo.OGN_FG !== '00') {
      return next('/PrListPage'); // 권한 없으면 홈으로 리다이렉트
    }
  }

  // 모바일 접속일 경우 본사(OGN_FG === '00') 사용자만 허용
  const isMobile = (() => {
    try {
      const ua =
        (typeof navigator !== "undefined" && navigator.userAgent) || "";
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        ua,
      );
    } catch (e) {
      return false;
    }
  })();

  if (isMobile && to.path !== "/") {
    try {
      if (!userInfo || String(userInfo.OGN_FG) !== "00") {
        alert("모바일에서는 본사 사용자만 접속 가능합니다.");
        next({ path: "/" });
        return;
      }
    } catch (e) {
      // parsing 에러 등 발생 시 안전하게 로그인 페이지로
      alert("모바일에서는 본사 사용자만 접속 가능합니다.");
      next({ path: "/" });
      return;
    }
  }

  // 인증이 필요 없거나, 사용자가 로그인한 경우 그대로 진행합니다.
  next();
});

export default router;
